const Search = (() => {
    const _onClick = (target) => {
        const input_id = target.getAttribute('data-search-input');
        const input = document.getElementById(input_id);
        target.dispatchEvent(new CustomEvent('inputSearch', { detail: { input } }));
    }

    return {
        setHandleEvent: () => {
            try {
                const targets = document.querySelectorAll('[data-search-input]');
                targets.forEach(button => {
                    const input = document.getElementById(button.getAttribute('data-search-input'));
                    button.addEventListener('click', _onClick.bind(this, button));
                    input.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter' || e.keyCode === 13) {
                            e.preventDefault();
                            _onClick.call(this, button);
                        }
                    });
                })
            } catch (error) { console.error(error) }
        }
    }
})();

const loadSearchHandler = () => {
    Search.setHandleEvent();
}

export { loadSearchHandler }